<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function() {
    function updatePriceColors() {
        // Regular price
        document.querySelectorAll('.price-item--regular').forEach(function(el) {
            el.style.color = 'green';
        });

        // Compare at price
        document.querySelectorAll('.price-item--sale, .price-item--compare').forEach(function(el) {
            el.style.color = 'red';
        });
    }

    // Initial run
    updatePriceColors();

    // If variant selection changes price
    document.querySelectorAll('form.product-form select, form.product-form input').forEach(function(input){
        input.addEventListener('change', updatePriceColors);
    });
});
